<!-- 成绩公示 -->
<template>
    <div  class="score-table">
        <div class="title">
            第{{round}}轮 成绩公示表({{ second }}秒)
            <el-button type="danger" @click="toggleFullScreen">大屏</el-button>
        </div>
        <div  v-if="isShow">
           <div class="matches-container">
            <el-card 
                v-for="item in tableData" 
                :key="item.id"
                class="match-card"
                shadow="hover"
            >
                <div class="table-number" :class="item.gamesId === 111 ? 'green-row' : '' ">
                    <span>{{ item.deskNo }}号桌</span>
                    <span>级牌：{{ item.poker }}</span>
                </div>
                <div class="team team-east">                   
                    <div class="">
                        <span class="team-position">东西</span>
                        <span class="team-role">{{ item.teamTypeWE }}</span>
                    </div>
                    <div class="team-info">
                        <span class="team-code">{{item.usernameWE}}</span>
                        <span class="team-name">{{ item.companyWE }}</span>
                    </div>
                    <div class="team-info">
                        <span class="team-code">成绩</span>
                        <span class="team-name red">{{ item.scoreWE }}</span>
                    </div>   
                </div>
                <div class="team team-south">                    
                    <div>
                        <span class="team-position">南北</span>
                        <span class="team-role">{{ item.teamTypeSN}}</span>
                    </div>
                    <div class="team-info">
                        <span class="team-code">{{ item.usernameSN}}</span>
                        <span class="team-name">{{ item.companySN}}</span>
                    </div>
                     <div class="team-info">
                        <span class="team-code">成绩</span>
                        <span class="team-name red">{{ item.scoreSN }}</span>
                    </div>
                </div>
            </el-card>
        </div>
        </div>      
    </div>
 </template> 
 <script>
 import Qrcode from '@/components/Qrcode'
import { mapState } from 'vuex'
 export default {
     props:{
        pubId: {
             type: String,
             default: ''
         },
        pubType: {
            type: String,
            default: ''
        }
     },
     components:{
        Qrcode,
     },
     data() {
         return {
            isShow: false,
            tableData: [],
            firstTableData: [],
            secondTableData: [],
            second: 5,
            timer: null,
            loading: false
         }
     },
     created() {
 
     },
     mounted() {
        
     },
     computed:{
        ...mapState(['round'])
    },
     methods: {
        tableCellClassName({row,column, rowIndex}){
            // console.log(row,column)
            // 成绩这一列一种颜色
            // if(column.property === 'usernameW' && row.statusW === '弃权'){
            //     return 'gray-row'
            // }
            // if(column.property === 'usernameS' && row.statusS === '弃权'){
            //      return 'gray-row'
            // }
            if(column.property === 'deskNo' && row.games === 111){
                return 'green-row'
            }
        },
        tableRowClassName({row, rowIndex}){
            // 一桌一种颜色
            if(row.deskNo % 2){
                return 'white-row'
            }else{
                return  'light-green-row'
            }
        },
         // 分数查询
         initData(){
            let params = {
                opcode: this.$code.ScoreNotice,
                i_serial_mark: this.pubId,
                i_round: this.round,
                i_games_id: 0,
                i_desk_no: 0
             }
             this.$api.requestAPI(params).then(res =>{
                 if (res.IsSuccess) {
                    let result = res.Data.DataTable
                    
                    if(result.length > 0) {  
                        this.isShow = true                      
                        let newArr   = result.map(item=>{
                        let username = `${item['选手名称']}/${item['搭档名称']}` 
                         return{
                            deskNo: item['桌号'],
                            id: item['选手编号'],
                            username: username,
                            phone: item['选手手机号'],
                            company: item['战队名称'],
                            userId: item['选手账号'],
                            seat: item['座位'],
                            round: item['第几轮'],
                            poker: item['成绩'],
                            partner: item['搭档名称'],
                            games: item['局数'],
                            status: item['状态'],
                            teamType: item['主客队'],
                            score: item['总升级']
                         }
                     })
                        this.tableData = this.selectDeskNo(newArr)
                        // console.log(this.tableData)
                    }else{
                        this.isShow = true
                        this.tableData = []
                        this.$message.error('请到编排界面，点击编排按钮！')
                        this.stopCountdown()
                    }                   
                 }
             }).catch(err=>{
                this.stopCountdown()
             })
         }, 
         selectDeskNo(arr){
            let result = []
            arr.forEach(item => {
                if(!result.some(i => i.deskNo === item.deskNo)){
                    let newArr = arr.filter(user => user.deskNo === item.deskNo)
                    let seatWE = (newArr.filter(i =>  i.seat.includes('东')))[0].seat
                    let seatSN = (newArr.filter(i =>  i.seat.includes('北')))[0].seat
                    let scoreWE = (newArr.filter(i =>  i.seat.includes('东')))[0].score
                    let scoreSN = (newArr.filter(i =>  i.seat.includes('北')))[0].score
                    let usernameWE = (newArr.filter(i =>  i.seat.includes('东')))[0].username 
                    let usernameSN = (newArr.filter(i =>  i.seat.includes('北')))[0].username  

                    let teamTypeWE = (newArr.filter(i =>  i.seat.includes('东')))[0].teamType
                    let teamTypeSN = (newArr.filter(i =>  i.seat.includes('北')))[0].teamType
                    
                    let companyA = (newArr.filter(i =>  i.seat.includes('东')))[0].company
                    let companyB = (newArr.filter(i =>  i.seat.includes('北')))[0].company
                    result.push({
                        deskNo: item.deskNo,
                        seatWE: seatWE,
                        seatSN: seatSN,
                        scoreWE: scoreWE,
                        scoreSN: scoreSN,
                        teamTypeWE: teamTypeWE,
                        teamTypeSN: teamTypeSN,
                        usernameWE: usernameWE,
                        usernameSN: usernameSN, 
                        status: item.status,
                        poker: item.poker,
                        companyWE: companyA,
                        companySN: companyB,
                        gamesId: item.games               
                    })
                }
            });
            return result
        },
        // 桌号和分数
        selectDeskNoNew(arr){
            let result = []
            arr.forEach(item => {
                 if(!result.some(i => i.deskNo === item.deskNo )){
                        let newArr = arr.filter(user => user.deskNo === item.deskNo)
                        let usernameW = (newArr.filter(i =>  i.seat.includes('东')))[0].username 
                        let usernameE = (newArr.filter(i =>  i.seat.includes('西')))[0].username
                        let usernameS = (newArr.filter(i =>  i.seat.includes('南')))[0].username
                        let usernameN = (newArr.filter(i =>  i.seat.includes('北')))[0].username
                        let scoreW = (newArr.filter(i =>  i.seat.includes('东')))[0].score
                        let scoreE = (newArr.filter(i =>  i.seat.includes('西')))[0].score
                        let scoreS = (newArr.filter(i =>  i.seat.includes('南')))[0].score
                        let scoreN = (newArr.filter(i =>  i.seat.includes('北')))[0].score    
                        let scoreWE = ''
                        let scoreSN= ''
                        let statusWE = ''
                        let statusSN = ''
                        let usernameWE = ''
                        let usernameSN = ''
                        if(this.pubType === '1'){
                            if(scoreW === '弃' && scoreE === '弃')  {
                                scoreWE = scoreW
                            }else if(scoreW === '弃' && scoreE !== '弃'){
                                scoreWE = scoreE
                            }else if(scoreW !== '弃' && scoreE === '弃'){
                                scoreWE =  scoreW
                            }else if(scoreW !== '弃' && scoreE !== '弃'){
                                scoreWE = scoreW
                            } 
                            if(scoreS === '弃' && scoreN === '弃')  {
                                scoreSN = scoreS
                            }else if(scoreS === '弃' && scoreN !== '弃'){
                                scoreSN = scoreN
                            }else if(scoreS !== '弃' && scoreN === '弃'){
                                scoreSN =  scoreS
                            }else if(scoreS !== '弃' && scoreN !== '弃'){
                                scoreSN = scoreS
                            } 
                        }else{
                            scoreWE =(newArr.filter(i =>  i.seat.includes('东')))[0].score
                            scoreSN = (newArr.filter(i =>  i.seat.includes('北')))[0].score

                            statusWE = (newArr.filter(i =>  i.seat.includes('东')))[0].status
                            statusSN =(newArr.filter(i =>  i.seat.includes('北')))[0].status  

                            usernameWE = (newArr.filter(i =>  i.seat.includes('东')))[0].username 
                            usernameSN = (newArr.filter(i =>  i.seat.includes('北')))[0].username      
                        }                       
                        result.push({
                            deskNo: item.deskNo,                            
                            usernameW: usernameW,
                            usernameE: usernameE,
                            usernameS: usernameS,
                            usernameN: usernameN,
                            scoreWE: scoreWE,
                            scoreSN: scoreSN,                              
                            games: item.games,                        
                            statusW: (newArr.filter(i =>  i.seat.includes('东')))[0].status,
                            statusE: (newArr.filter(i =>  i.seat.includes('西')))[0].status,
                            statusS: (newArr.filter(i =>  i.seat.includes('南')))[0].status,
                            statusN: (newArr.filter(i =>  i.seat.includes('北')))[0].status,
                            statusWE: statusWE,
                            statusSN: statusSN,
                            usernameWE: usernameWE,
                            usernameSN: usernameSN,
                        })
                 }
             });
             return result
        }, 
        stopCountdown(){
            clearInterval(this.timer)
            this.timer = null
        },
        countDown(){            
            this.timer = setInterval(()=>{
                if(this.second >0){
                    this.second--
                }else{
                    this.second = 10
                    this.initData()
                }
            },1000)
        },
        toggleFullScreen(){
            const routeUrl = this.$router.resolve({ name: 'teamFullScoreRefresh', 
            query: { id: this.pubId,}});
            window.open(routeUrl.href, '_blank');   
            
        }, 
     },
     destroyed(){
        this.stopCountdown()  
     },
     beforeDestroy() {
        this.stopCountdown()  
     },
 }
 </script>
 <style lang='scss' scoped>
 @import '@/assets/css/style.scss';
 .title{
     font-size: 28px;
     margin-bottom: 10px;
 }

 .light-green-row{
    background-color: #bbffbb
  }

.gray-row{
    background-color: #b9b5b5;
}
.white-row{
    background-color: #f0f9eb;
  } 

.matches-container {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
    gap: 20px;
    margin-bottom: 30px;
}

.match-card {
    background: white;
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08);
    transition: transform 0.3s, box-shadow 0.3s;
}

.match-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.table-number {
    text-align: center;
    font-weight: bold;
    margin-bottom: 15px;
    padding-bottom: 10px;
    border-bottom: 2px solid #eee;
    color: #1a6bc4;
    background-color: #f8f9fa;
    padding: 12px;
    border-radius: 8px;
    font-size: 18px;
    display: flex;
    justify-content: space-between;
}

.team {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 12px 0;
    padding: 12px;
    border-radius: 8px;
}

.team-east {
    background-color: #e8f4fd;
    border-left: 5px solid #1a6bc4;
}

.team-south {
    background-color: #fff8e1;
    border-left: 5px solid #ffa000;
}

.team-position {
    font-weight: bold;
    color: #555;
    min-width: 70px;
    font-size: 16px;
}

.team-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-grow: 1;
    text-align: center;
}

.team-code {
    font-weight: bold;
    color: #1a6bc4;
    font-size: 18px;
    margin-bottom: 5px;
}

.team-name {
    font-size: 18px;
    color: #666;
}

.team-role {
    font-size: 16px;
    color: #ec0303;
    // min-width: 50px;
    text-align: right;
    background: rgba(0, 0, 0, 0.05);
    padding: 4px 8px;
    border-radius: 4px;
}
.red{
    color: #000;
    font-size: 20px;
    font-weight: bold;
}
.teams-info {
    background: white;
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08);
}

.teams-title {
    font-weight: bold;
    margin-bottom: 15px;
    color: #1a6bc4;
    border-bottom: 2px solid #eee;
    padding-bottom: 8px;
    font-size: 16px;
}

.teams-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
    gap: 12px;
}

.team-item {
    padding: 12px;
    background: #f8f9fa;
    border-radius: 8px;
    text-align: center;
    font-weight: bold;
    border-left: 4px solid #1a6bc4;
}

.round-buttons {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}

.action-buttons {
    display: flex;
    gap: 10px;
}

@media (max-width: 768px) {
    .header {
        flex-direction: column;
        text-align: center;
    }
    
    .round-info {
        margin-bottom: 15px;
    }
    
    .matches-container {
        grid-template-columns: 1fr;
    }
    
    .controls {
        flex-direction: column;
        align-items: flex-start;
        gap: 15px;
    }
    
    .round-buttons, .action-buttons {
        width: 100%;
        justify-content: center;
    }
}
 .green-row{
    background-color: green;
    color: #fff
  }
 </style>


// WEBPACK FOOTER //
// src/views/team/components/scoreRefresh.vue